export default __webpack_public_path__ + "static/media/ksivalue_small.ed6176bc.jpg";